import { Link } from '../../../components/Link';
import { Seo } from '../../../lib/seo';
import { LegalLayout } from '../../../components/LegalLayout';
import { useLegalPagesVisible } from '../../../lib/useLegalPagesVisible';
import type { LegalPageKey } from '../../../lib/types';

const PAGES: ReadonlyArray<readonly [LegalPageKey, string, string, string]> = [
  ['privacy', '/privacy', 'Privacy Policy', 'How we collect, use, and protect personal data.'],
  ['terms', '/terms', 'Terms of Use', 'The contract you agree to by using SieveGuard.'],
  ['dpa', '/dpa', 'Data Processing Agreement', 'GDPR Art. 28 — Customer (Controller) ↔ SieveGuard (Processor).'],
  ['gdpr', '/gdpr', 'GDPR compliance', 'Plain-English summary of our data-protection posture.'],
  ['aup', '/aup', 'Acceptable Use Policy', 'What you can and cannot do with the service.'],
  ['subprocessors', '/subprocessors', 'Sub-processors', 'Third parties that process data on our behalf.'],
  ['cookies', '/cookies', 'Cookie Policy', 'What cookies we set and how to control your consent.'],
  ['contact', '/contact', 'Contact', 'How to reach us — general, billing, and privacy.'],
];

export function LegalIndexPage() {
  const { isVisible } = useLegalPagesVisible();
  const published = PAGES.filter(([key]) => isVisible(key));
  return (
    <><Seo title="Legal" description="SieveGuard legal documents — Privacy Policy, Terms of Use, DPA, GDPR compliance, AUP, sub-processors." path="/legal" /><LegalLayout title="Legal">
      <p>
        Everything that governs how you use SieveGuard and how we handle data — all in one place.
        Skim the cards below or jump straight to a specific document via the sidebar.
      </p>

      <div className="not-prose mt-8 grid gap-3 sm:grid-cols-2">
        {published.map(([, to, label, blurb]) => (
          <Link
            key={to}
            to={to}
            className="rounded-2xl border border-bordersoft bg-panel p-5 transition hover:border-accentdeep hover:bg-panel2"
          >
            <div className="text-base font-semibold text-txt">{label}</div>
            <div className="mt-1 text-[13px] text-muted">{blurb}</div>
          </Link>
        ))}
      </div>
    </LegalLayout></>
  );
}

// Default export required by React Router framework-mode route modules.
export default LegalIndexPage;
